import { Dropdown } from 'primereact/dropdown';
import { Fieldset } from 'primereact/fieldset';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import paramService from './parameter-service';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import BreadcrumbComponent from '../../../../components/Breadcrumb';


interface DropdownItem {
    fullDesc: string;
    referenceCode: string;
}



const ParameterEdit: React.FC = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const paramData = location.state?.param;
    const isEditMode = !!paramData;
    const toast = useRef<Toast>(null);
    const [loading, setLoading] = useState(false);
    const [checkboxValue, setCheckboxValue] = useState<string[]>([]);
    const [clientState, setClientState] = useState<any>(null);
    const [formData, setFormData] = useState<any>({});
    const [errors, setErrors] = useState<any>({});
    const currentDate = new Date().toLocaleString("en-US", { timeZone: clientState?.timeZone });

    useEffect(() => {
        const fetchClientState = async () => {
            try {
                const clientStateItem = await paramService.getClientState();
                setClientState(clientStateItem);

                if (isEditMode) {
                    setFormData(paramData)
                }

            } catch (error) {
                console.error('Error fetching client state:', error);
            }
        };

        fetchClientState();
    }, []);

    const validate = () => {
        let valid = true;

        // if (!formData.departmentCode) {
        //     errors.departmentCode = 'Department is required';
        //     valid = false;
        // }
        // if (!formData.fullDesc) {
        //     errors.fullDesc = 'Full Description is required';
        //     valid = false;
        // }
        // if (!formData.departmentCategory) {
        //     errors.departmentCategory = 'Department Category is required';
        //     valid = false;
        // }
        setFormData({ ...formData, errors });
        return valid;
    }

    const handleInputChange = (e: any) => {
        const { id, value } = e.target;
        setFormData({
            ...formData,
            [id]: value.toUpperCase()
        });
    };

    const handleParamValueInputChange = (e: any) => {
        const { id, value } = e.target;
        setFormData({
            ...formData,
            [id]: value
        });
    };

    const handleDropdownChange = (e: any) => {
        const { id, value } = e.target;
        setFormData({
            ...formData,
            [id]: value
        });
    };

    const footerToolbar = () => {
        function handleBack(): void {
            navigate('/admin/parameter');
        }
        function handleSave(event: React.FormEvent): void {
            event.preventDefault();

            if (validate()) {

                setLoading(true);


                if (isEditMode) {
                    formData.modifiedBy = clientState.userId;
                    formData.modifiedDate = currentDate
                } else {
                    formData.insertBy = clientState.userId;
                    formData.insertDate = currentDate;
                    formData.modifiedBy = clientState.userId;
                    formData.modifiedDate = currentDate;
                    formData.facilityCode = clientState.facilityCode;
                }

                if (isEditMode) {
                    paramService.update(formData.parameterId, formData).then((response) => {
                        const data = response.data;
                        clientState.success.detail = 'Already Save Record';
                        toast.current?.show(clientState.success);
                        navigate("/admin/parameter");
                    }).catch((error) => {
                        console.error('Error updating module:', error);
                        toast.current?.show({ severity: 'error', summary: 'Update Module', detail: 'Error updating module' });
                    }).finally(() => {
                        setLoading(false);
                    });
                } else {
                    paramService.create(formData).then((response) => {
                        const data = response.data;
                        clientState.success.detail = 'Already Save Record';
                        toast.current?.show(clientState.success);
                        navigate("/admin/parameter");
                    }).catch((error) => {
                        console.error('Error updating module:', error);
                        toast.current?.show({ severity: 'error', summary: 'Update Module', detail: 'Error updating module' });
                    }).finally(() => {
                        setLoading(false);
                    });
                }
            }


        }

        return (
            <>
                <Toast ref={toast} />
                <Button label="Save" icon="pi pi-check" style={{ marginRight: '.5em' }} onClick={handleSave} disabled={loading}>

                </Button>
                {/* <Button label="Delete" icon="pi pi-trash" style={{ marginRight: '.5em' }} /> */}
                <Button label="Back" icon="pi pi-times" style={{ marginRight: '.5em' }} onClick={handleBack}>

                </Button>

            </>
        );
    };

    return (
        <div className='grid'>
            <div className='col-12'>
                <div className='card-title'>
                    <h5>Parameter</h5>
                    <BreadcrumbComponent />
                </div>
                <div className='form-title'>
                    <Fieldset legend="Parameter Information">
                        <div className="p-fluid form-grid grid">
                            <div className="field col-12 md:col-6">
                                <label>Parameter Id</label>
                                <InputText
                                    id="parameterId"
                                    value={formData.parameterId}
                                    onChange={handleInputChange}
                                />
                                {errors.parameterId && <small className="p-error">{errors.parameterId}</small>}
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Full Description</label>
                                <InputText
                                    id="fullDesc"
                                    value={formData.fullDesc}
                                    onChange={handleInputChange}
                                />
                                {errors.fullDesc && <small className="p-error">{errors.fullDesc}</small>}
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Module Id</label>
                                <InputText
                                    id="moduleId"
                                    value={formData.moduleId}
                                    onChange={handleInputChange}
                                />
                                {errors.moduleId && <small className="p-error">{errors.moduleId}</small>}
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Parameter Type</label>
                                <InputText
                                    id="parameterType"
                                    value={formData.parameterType}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Parameter Value</label>
                                <InputText
                                    id="parameterValue"
                                    value={formData.parameterValue}
                                    onChange={handleParamValueInputChange}
                                />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Program Url</label>
                                <InputText
                                    id="programUrl"
                                    value={formData.programUrl}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="field col-12 md:col-6">
                                <h6>Admin Permission</h6>
                                <InputSwitch
                                    checked={formData.adminOnly === "Y"}
                                    onChange={(e) =>
                                        setFormData({ ...formData, adminOnly: e.value ? "Y" : "N" })
                                    }
                                />
                            </div>
                            <div className="field col-12">
                                <label htmlFor="remark">Remarks</label>
                                <InputTextarea
                                    id="remark"
                                    value={formData.remark}
                                    onChange={(e) =>
                                        setFormData({ ...formData, remark: e.target.value })
                                    }
                                    rows={4} />
                            </div>
                        </div>
                    </Fieldset>
                    <div>
                        <br />
                    </div>
                    <Toolbar end={footerToolbar}></Toolbar>
                </div>
            </div>
        </div>
    );
};

export default ParameterEdit;